<template>
  <!-- 固件升级/升级任务详情 -->
  <div class="upgrade-page">
    <el-tabs v-model="activeName" class="tabs">
      <!-- 升级情况 -->
      <el-tab-pane
        :label="$t('pages.equipment.text211')"
        name="UpgradeSituation"
        class="tabs-content"
      >
        <UpgradeSituationModel
          :activeName="activeName"
          :formalUpgradeInfo="formalUpgradeInfo"
          @UpgradeTaskInfo="UpgradeTaskInfo"
        />
      </el-tab-pane>
      <!-- 升级任务 -->
      <el-tab-pane
        :label="$t('pages.equipment.text210')"
        name="upgradeTask"
        class="tabs-content"
      >
        <UpgradeTaskModel
          :activeName="activeName"
          :formalUpgradeInfo="formalUpgradeInfo"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import UpgradeTaskModel from "./module/upgradeTaskModel.vue";
import UpgradeSituationModel from "./module/upgradeSituationModel.vue";
export default {
  data() {
    return {
      activeName: null,
      params: {
        id: "", //主键id
      },
      formalUpgradeInfo: {},
    };
  },
  mounted() {
    this.params.id = this.$route.query.id;
    this.UpgradeTaskInfo();
    this.activeName = "upgradeTask";
  },
  components: {
    UpgradeTaskModel,
    UpgradeSituationModel,
  },
  methods: {
    UpgradeTaskInfo(e) {
      this.params = { ...this.params, ...e };
      this.request.UpgradeTaskInfo(this.params).then((res) => {
        this.formalUpgradeInfo = res.data;
      });
    },
  },
};
</script>

<style scoped>
.upgrade-page {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.tabs-content {
  width: 100%;
  height: 100%;
}
</style>